import { getEnv } from '../utils/getEnv';

const { VITE_API_ROOT_URL, VITE_API_USER_ROOT_URL } = getEnv();

const endpoints = {
  businessProfile: (businessId: string) => `${VITE_API_ROOT_URL}/businesses/${businessId}`,
  businessReviews: (businessId: string) => `${VITE_API_ROOT_URL}/businesses/${businessId}/reviews`,
  businessSearch: `${VITE_API_ROOT_URL}/providers/search`,
  config: `${VITE_API_ROOT_URL}/config/categories`,
  newsletter: `${VITE_API_ROOT_URL}/marketing/newsletter/subscribe`,
  user: (id: string) => `${VITE_API_USER_ROOT_URL}/users/${id}`,
  userDetails: (email: string) => `${VITE_API_USER_ROOT_URL}/users?email=${email}`,
};

export default endpoints;
